module.exports = __webpack_public_path__ + "static/media/ad-post-mockup-upper-myfeed.112da8ed.png";